import React from 'react'
import * as StyledComponent from '../styles'

const BottomSheetBtn = ({
  label,
  onClick
}, context) => (
  <div className='btn-container'>
    <StyledComponent.AddToBagBtn
      // className='btn'
      onClick={onClick}
    >
      {label}
    </StyledComponent.AddToBagBtn>
  </div>
)

export default BottomSheetBtn



// WEBPACK FOOTER //
// ./src/components/BottomSheetBtn.js